module.exports = __webpack_public_path__ + "img/Betting_text05a_regardless.b4c03409.png";